import { CollectStatus } from '@/types/common'
import { useContext, useState } from 'react'
import { SUCCESS_CODE, UNAUTHORIZED_CODE } from '@/utils/constants'
import type { Res } from '@/types/api'
import { AxiosResponse } from 'axios'
import { LayoutContext } from '@/context'

const useCollect = ({
  collectStatus,
  onCollect,
  onUnCollect
}: {
  collectStatus: number
  onCollect: () => Promise<AxiosResponse<Res>>
  onUnCollect: () => Promise<AxiosResponse<Res>>
}) => {
  const [isCollected, setIsCollected] = useState(collectStatus === CollectStatus.Star)
  const [isLoading, setIsLoading] = useState(false)
  const { onShowMemberModal } = useContext(LayoutContext)

  const toggleCollect = () => {
    const api = isCollected ? onUnCollect : onCollect

    setIsLoading(true)
    api()
      .then((res) => {
        if ([UNAUTHORIZED_CODE].includes(res.data.code)) {
          onShowMemberModal({
            errorMsg: res.data.msg
          })
          return
        }
        if (res.data.code === SUCCESS_CODE) {
          setIsCollected((prev) => !prev)
        }
      })
      .finally(() => {
        setIsLoading(false)
      })
  }

  return {
    isCollected,
    isLoading,
    toggleCollect
  }
}

export default useCollect
